'use client';

import Icon from './Icon';
import svg from 'sprites/telegram.svg';

export default function IconTelegram({
  className = 'w-8 h-8 fill-none stroke-white'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
